import { useQuery } from '@tanstack/react-query';

import { organizationApi } from '@/api/organization-admin/organization';
import { availableOrganizationsKeys } from '../../api/query-keys/available-organizations';

export const useOrganizationKiosks = () => {
  return useQuery({
    queryKey: availableOrganizationsKeys.all,
    queryFn: organizationApi.fetchOrganizationKiosks,
  });
};
